import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { LastTransferSubjectsDto } from '../schema/types';
import { UserCalendarUrl } from '../../UserDashboardUrl';

const getLastTransferSubjects = () =>
  apiClient
    .get<LastTransferSubjectsDto>(
      expand(UserCalendarUrl.LAST_TRANSFER_SUBJECTS),
    )
    .then((response) => response.data);

export const useGetLastTransferSubjectsQuery = createApiQueryHook(
  ['last-transfer-subjects'],
  getLastTransferSubjects,
);
